import { Link } from 'gatsby';
import useSiteMetadata from '../hooks/useSiteMetadata';
import CharacterStagger from './CharacterStagger';

export interface NavigationLink {
    id: string;
    label: string;
    url: string;
}

interface NavigationProps {
    mobile?: boolean;
    onCloseMenu?: () => void;
    links?: NavigationLink[];
    bookingUrl?: string;
}

const Navigation = ({
    mobile = false,
    onCloseMenu,
    links,
    bookingUrl,
}: NavigationProps): JSX.Element => {
    const site = useSiteMetadata();
    const usedLinks =
        links ||
        [
            { id: 'shopify', label: 'Shopify', url: '/shopify-agentur-koeln/' },
            { id: 'shopify-plus', label: 'Shopify Plus', url: '/shopify-plus-agentur/' },
            { id: 'migration', label: 'Migration', url: '/shopify-migration/' },
            { id: 'headless', label: 'Headless', url: '/headless-shopify/' },
        ];

    const callUrl = bookingUrl || site?.bookingUrl;

    const mobileLinkBase =
        'text-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-black';
    const desktopLinkBase =
        'btn-animate-chars nav-item focus-visible:outline focus-visible:outline-2 focus-visible:outline-black';

    if (mobile) {
        return (
            <nav
                role="navigation"
                aria-label="Mobile Navigation"
                className="flex flex-col gap-y-4 px-7 pt-24"
            >
                {usedLinks.map(({ id, label, url }) => (
                    <Link
                        key={id}
                        to={url}
                        onClick={onCloseMenu}
                        className={mobileLinkBase}
                        partiallyActive
                    >
                        {label}
                    </Link>
                ))}
                {callUrl && (
                    <Link
                        to="/kontakt/"
                        role="button"
                        className="rounded-btn bg-darkGreen text-white inline-flex items-center transition-shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-black mt-6"
                        onClick={onCloseMenu}
                    >
                        Kontakt
                    </Link>
                )}
            </nav>
        );
    }

    return (
        <nav
            role="navigation"
            aria-label="Hauptnavigation"
            className="hidden items-center lg:flex"
        >
            <div className="inline-flex items-center gap-x-8 px-10 py-5">
                {usedLinks.map(({ id, label, url }) => (
                    <Link
                        key={id}
                        to={url}
                        onClick={onCloseMenu}
                        className={desktopLinkBase}
                        activeClassName="is-active"
                    >
                        <CharacterStagger text={label} className="flex items-center" />
                    </Link>
                ))}
            </div>
            {callUrl && (
                <Link
                    to="/kontakt/"
                    role="button"
                    className="rounded-btn bg-white inline-flex items-center btn-animate-chars focus-visible:outline focus-visible:outline-2 focus-visible:outline-black"
                    onClick={onCloseMenu}
                >
                    <CharacterStagger text="Kontakt" className="flex items-center" />
                </Link>
            )}
        </nav>
    );
};

export default Navigation;
